module.exports = __webpack_public_path__ + "img/logoFornecedor.16556e0f.png";